<template>
  <!--
  <div class="word" @mouseover="word = french" :class="{'copper' : level==1, 'silver' : level==2, 'gold' : level>=3}"
       @mouseleave="word = english" :style="{width:longest(english, french)*0.7+'em'}">
    <transition name="fade"  mode="out-in">
      <span :key="word">{{word}}</span>
    </transition>


  </div>
  -->
  <div class="wordContainer mediumShadow" :style="styleObject">
    <i class="fas fa-clock clock" :title="'Mot disponible en révision dans '+ (10-Math.floor(timeSinceLearnt/60)) + ' heures'" v-if="timeSinceLearnt<600 && review && lemma.user_lemma[0].knowledge_level < 3"></i>
    <div class="english">{{englishWord}}</div>
    <div class="french">{{lemma.separateTrads[0]}}</div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
name: "learntWord",
  props:{
    lemma: null,
    to_delete: null,
    review: {type: Boolean, default: false},
  },

  created() {
    if (this.lemma.user_lemma.length === 0){
      this.lemma.user_lemma.push({
        'knowledge_level' : 0
      })
    }
  },

  methods: {
    longest: function (word1, word2) {
      return word1.length < word2.length ? word2.length : word1.length;
    },
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
    timeSinceLearnt: function() {
      let last_studied = new Date(this.lemma.user_lemma[0].last_studied)
      return Math.abs(new Date() - last_studied)/60000
    },
    styleObject: function() {
      let color = ''
      let colorDark = ''
      let bgcolor = ''
      let bgcolorDark = ''
      if (this.to_delete){
        bgcolor = '#ff9999'
        bgcolorDark = '#550000'
        color = '#550000'
        colorDark = '#ff9999'
      }
      else if (this.lemma.user_lemma[0].knowledge_level >= 3){
        bgcolor = 'var(--goldBackground)'
        bgcolorDark = 'var(--goldDarkBackground)'
        color = 'var(--goldColor)'
        colorDark = 'var(--goldDarkColor)'
      }
      else if (this.lemma.user_lemma[0].knowledge_level == 2){
        bgcolor = 'var(--silverBackground)'
        bgcolorDark = 'var(--silverDarkBackground)'
        color = 'var(--silverColor)'
        colorDark = 'var(--silverDarkColor)'
      }
      else if (this.lemma.user_lemma[0].knowledge_level == 1){
        bgcolor = 'var(--copperBackground)'
        bgcolorDark = 'var(--copperDarkBackground)'
        color = 'var(--copperColor)'
        colorDark = 'var(--copperDarkColor)'
      }
      else if (this.lemma.user_lemma[0].knowledge_level == 0){
        bgcolor = 'var(--standardBackground)'
        bgcolorDark = 'var(--standardDarkBackground)'
        color = 'var(--standardColor)'
        colorDark = 'var(--standardDarkColor)'
      }
      return {
        '--color': color,
        '--colordark': colorDark,
        '--bgcolor': bgcolor,
        '--bgcolordark': bgcolorDark,
      }
    },
    englishWord: function () {
      return this.lemma.decenglish
    },
  },
  data() {
    return {
      word: this.english
    }
  }
}
</script>

<style scoped>
  .wordContainer{
    position: relative;
    width: fit-content;
    margin-left: 0.25vw;
    margin-right: 0.25vw;
    margin-bottom: 0.5vw;
    /*border: 0.2vw var(--colordark) solid;*/
    background-color: var(--bgcolordark);
    padding: 0 0.6vw 0 0 ;
    border-radius: 0.6vw;
  }
  .clock{
    position: absolute;
    right: -0.1vw;
    top: -0.1vw;
    font-size: 80%;
    color: var(--bgcolor);
  }
  .english{
    width: 100%;
    height: 1.2vw;
    padding: 0.2vw 0.3vw 0vw 0.3vw ;
    font-weight: bold;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    color: var(--colordark);
  }
  .french{
    background-color: var(--bgcolor);
    color: var(--color);
    width: 100%;
    height: 1.2vw;
    padding: 0.1vw 0.3vw 0.1vw 0.3vw ;
    /*font-weight: bold;*/
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    border-radius: 0 0 0.6vw 0.6vw;
  }
  @media screen and (max-device-width: 767px) {
    .wordContainer {
      font-size: 110%;
      padding: 0 2vw 0 0 ;
      margin-left: 1vw;
      margin-right: 1vw;
      border-radius: 2.4vw;
      margin-bottom: 2vw;
    }
    .english{
      height: 4.8vw;
      padding: 0.8vw 1vw 0vw 1vw ;
    }
    .french{
      height: 4.8vw;
      padding: 0.4vw 1vw 0.4vw 1vw ;
      border-radius: 0 0 2.4vw 2.4vw;
    }
  }
</style>